<template>
  <div>
    <div v-if="this.endWelcomeTour" class="text-center">
      <v-btn
        variant="text"
        icon
        class="tour-button"
        color="#a5d867"
        @click="startTour"
      >
        <v-icon @click="startTour" :icon="'guide'" />
      </v-btn>
    </div>
    <v-tour
      name="myWelcomeTour"
      class="app-welcome-tour"
      :steps="steps"
      :callbacks="myCallbacks"
      :options="{
        labels: {
          buttonSkip: $t('common.tourSkip'),
          buttonPrevious: $t('common.tourPrevious'),
          buttonNext: $t('common.tourNext'),
          buttonStop: $t('common.tourFinish'),
        },
      }"
    ></v-tour>
  </div>
</template>

<script>
  import { useUITranslations } from '@/helpers/useUITranslations'
  import { useLanguages } from '@/helpers/useLanguages'
  import { currentLocale } from '@/helpers/localePath'

  export default {
    name: 'my-church-pin-tour',
    setup() {
      const { t } = useUITranslations()
      const { defaultLang } = useLanguages()
      return { t, defaultLang, currentLocale }
    },
    data() {
      return {
        endWelcomeTour: null,
        myCallbacks: {
          onSkip: this.customSkipCallback,
          onFinish: this.customFinishCallback,
        },
      }
    },
    computed: {
      steps() {
        // Try to get steps from database first using current locale
        const currentLang = this.currentLocale()
        const dbSteps = this.t('tourSteps', currentLang)

        // Hardcoded params for each step (these never change)
        const hardcodedParams = [
          {
            target: '.menu-items-container',
            params: {
              placement: 'left',
              enableScrolling: false,
              highlight: true,
            },
          },
          {
            target: '.menu-items-container',
            params: {
              placement: 'left',
              enableScrolling: false,
              highlight: true,
            },
          },
          {
            target: '#launcher',
            params: {
              placement: 'top',
              enableScrolling: false,
              highlight: true,
            },
          },
          {
            target: '.user-guides-container',
            params: {
              placement: 'top',
              enableScrolling: false,
              highlight: true,
            },
          },
        ]

        // Fallback hardcoded steps with full content
        const fallbackSteps = [
          {
            target: '.menu-items-container',
            header: {
              title: 'Menu',
            },
            content: `Edit your Profile, View FAQs, Change your Theme or Logout of your account from here.`,
            params: {
              placement: 'left',
              enableScrolling: false,
              highlight: true,
            },
          },
          {
            target: '.menu-items-container',
            header: {
              title: 'Admin',
            },
            content: `If you are a Church admin or Leader you can access the admin dashboard.`,
            params: {
              placement: 'left',
              enableScrolling: false,
              highlight: true,
            },
          },
          {
            target: '#launcher',
            header: {
              title: 'Help/Feedback',
            },
            content: `If you have any issues or questions feel free to use our help chat/feedback center.`,
            params: {
              placement: 'top',
              enableScrolling: false,
              highlight: true,
            },
          },
          {
            target: '.user-guides-container',
            header: {
              title: 'User Guides',
            },
            content: `Check out these two guides before you start your Journey.`,
            params: {
              placement: 'top',
              enableScrolling: false,
              highlight: true,
            },
          },
        ]

        if (
          Array.isArray(dbSteps) &&
          dbSteps.length > 0 &&
          typeof dbSteps[0] === 'object'
        ) {
          // Merge database content with hardcoded params
          return dbSteps.map((dbStep, index) => ({
            ...hardcodedParams[index], // target and params
            content: dbStep.content || fallbackSteps[index].content,
            header: {
              title: dbStep.title || fallbackSteps[index].header.title, // Fixed: use dbStep.title not dbStep.header?.title
            },
          }))
        }

        // Fallback to hardcoded steps
        return fallbackSteps
      },
    },
    methods: {
      customSkipCallback() {
        this.endWelcomeTour = true
        localStorage.endWelcomeTour = true
        this.enableNavigation()
      },
      customFinishCallback() {
        this.endWelcomeTour = true
        localStorage.endWelcomeTour = true
        this.enableNavigation()
      },
      enableNavigation() {
        // Remove any tour overlays that might block navigation
        const tourOverlay = document.querySelector(
          '.v-tour__target--highlighted'
        )
        if (tourOverlay) {
          tourOverlay.style.pointerEvents = 'auto'
        }
        // Force re-enable all navigation elements
        document.body.style.pointerEvents = 'auto'
      },
      startTour() {
        localStorage.removeItem('endWelcomeTour')
        this.endWelcomeTour = null
        this.$tours['myWelcomeTour'].start()
      },
    },
    mounted: function () {
      this.endWelcomeTour = localStorage.endWelcomeTour
      if (!localStorage.endWelcomeTour) {
        setTimeout(() => {
          this.$tours['myWelcomeTour'].start()
        }, 1000)
      }

      // Listen for route changes and auto-end tour if user navigates
      this.unwatch = this.$router.beforeEach((to, from, next) => {
        if (
          this.$tours &&
          this.$tours['myWelcomeTour'] &&
          this.$tours['myWelcomeTour'].isRunning
        ) {
          this.$tours['myWelcomeTour'].stop()
          this.customSkipCallback()
        }
        next()
      })
    },
    beforeUnmount() {
      // Clean up the router guard
      if (this.unwatch) {
        this.unwatch()
      }
    },
  }
</script>
<style>
  /* body .v-tour__target--highlighted {
    box-shadow: 0 0 0 99999px rgba(0,0,0,.4);
  } */
  body .v-application .v-tour__target--highlighted {
    -webkit-box-shadow: 0 0 0 4px rgba(0, 0, 0, 0.4) !important;
    box-shadow: 0 0 0 4px rgba(0, 0, 0, 0.4) !important;
  }
  body .v-application.v-theme--dark .v-tour__target--highlighted {
    -webkit-box-shadow: 0 0 0 4px rgb(85 86 81) !important;
    box-shadow: 0 0 0 4px rgb(85 86 81) !important;
  }
  .tour-button {
    position: fixed;
    left: 20px;
    bottom: 20px;
  }
</style>
